module.exports = __webpack_public_path__ + "img/eye.254ef9cc.svg";